var map = {
	"../common-pages/common-pages.module": [
		"./src/app/home/common-pages/common-pages.module.ts",
		"default~common-pages-common-pages-module~home-home-module"
	],
	"../components/appointment-dashboard/appointment-dashboard.module": [
		"./src/app/home/internal/components/appointment-dashboard/appointment-dashboard.module.ts",
		"components-appointment-dashboard-appointment-dashboard-module"
	],
	"../components/clinic-management/clinic-management.module": [
		"./src/app/home/internal/components/clinic-management/clinic-management.module.ts",
		"components-clinic-management-clinic-management-module"
	],
	"../components/external-pending-dashboard/external-pending-dashboard.module": [
		"./src/app/home/external/components/external-pending-dashboard/external-pending-dashboard.module.ts",
		"components-external-pending-dashboard-external-pending-dashboard-module"
	],
	"../components/medical-record-dashboard/medical-record-dashboard.module": [
		"./src/app/home/internal/components/medical-record-dashboard/medical-record-dashboard.module.ts",
		"components-medical-record-dashboard-medical-record-dashboard-module"
	],
	"../components/pending-dashboard/pending-dashboard.module": [
		"./src/app/home/internal/components/pending-dashboard/pending-dashboard.module.ts",
		"components-pending-dashboard-pending-dashboard-module"
	],
	"../components/prescription-dashboard/prescription-dashboard.module": [
		"./src/app/home/internal/components/prescription-dashboard/prescription-dashboard.module.ts",
		"components-prescription-dashboard-prescription-dashboard-module"
	],
	"../components/reports/internal-reports.module": [
		"./src/app/home/internal/components/reports/internal-reports.module.ts",
		"components-reports-internal-reports-module"
	],
	"../components/reports/reports.module": [
		"./src/app/home/external/components/reports/reports.module.ts",
		"components-reports-reports-module"
	],
	"../components/today-dashboard/today-dashboard.module": [
		"./src/app/home/external/components/today-dashboard/today-dashboard.module.ts",
		"components-today-dashboard-today-dashboard-module"
	],
	"../components/user-management/user-management.module": [
		"./src/app/home/internal/components/user-management/user-management.module.ts",
		"components-user-management-user-management-module"
	],
	"../external/external.module": [
		"./src/app/home/external/external.module.ts",
		"external-external-module"
	],
	"../internal/internal.module": [
		"./src/app/home/internal/internal.module.ts",
		"internal-internal-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"default~common-pages-common-pages-module~home-home-module",
		"home-home-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;